/* ── Vulpera Shopify Custom Theme JavaScript ────────────────────────── */
const isLocalPreview = window.location.protocol === 'file:' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

document.addEventListener('DOMContentLoaded', () => {

    // 1. Dynamic Sticky Header & Announcement Bar Coordinate Sync
    function updateStickyHeaderPositions() {
        const annBarSection = document.getElementById('shopify-section-announcement-bar') || document.querySelector('.shopify-section-announcement-bar');
        const annBarInner = document.getElementById('announcement-bar');
        const root = document.documentElement;

        let height = 0;
        if (annBarSection && window.getComputedStyle(annBarSection).display !== 'none') {
            height = annBarSection.offsetHeight;
        } else if (annBarInner && window.getComputedStyle(annBarInner).display !== 'none') {
            height = annBarInner.offsetHeight;
        }

        root.style.setProperty('--announcement-bar-height', `${height}px`);
    }

    // Run position sync immediately and on window events
    updateStickyHeaderPositions();
    window.addEventListener('resize', updateStickyHeaderPositions);
    window.addEventListener('load', updateStickyHeaderPositions);

    // 1.b. Sticky Navbar Scroll Effect
    const navbar = document.getElementById('navbar');
    if (navbar) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 30) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        }, { passive: true });
    }

    // 2. Announcement Bar Close with Smooth Header Readjustment
    const annBar = document.getElementById('announcement-bar');
    const annClose = document.getElementById('announcement-close-btn');
    if (annBar && annClose) {
        annClose.addEventListener('click', () => {
            annBar.style.display = 'none';
            const annSection = document.getElementById('shopify-section-announcement-bar');
            if (annSection) annSection.style.display = 'none';
            updateStickyHeaderPositions();
        });
    }

    // 2.b. Kwikpass & 3rd-Party App Embeds Sticky Header Protection
    // Prevents injected overflow:hidden from breaking position:sticky on html/body
    function enforceStickyFriendlyOverflow() {
        const html = document.documentElement;
        const body = document.body;
        
        // Ensure overflow-x is clip and not scroll/hidden container that breaks sticky
        if (window.getComputedStyle(html).overflowX === 'hidden') {
            html.style.setProperty('overflow-x', 'clip', 'important');
        }
        if (window.getComputedStyle(body).overflowX === 'hidden') {
            body.style.setProperty('overflow-x', 'clip', 'important');
        }
        updateStickyHeaderPositions();
    }

    if (window.MutationObserver) {
        const embedObserver = new MutationObserver((mutations) => {
            for (let mutation of mutations) {
                if (mutation.type === 'attributes' && (mutation.attributeName === 'style' || mutation.attributeName === 'class')) {
                    enforceStickyFriendlyOverflow();
                }
            }
        });
        embedObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'class'] });
        embedObserver.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
    }
    enforceStickyFriendlyOverflow();

    // 3. Mobile Navigation Drawer
    const hamburgerBtn = document.getElementById('hamburger-btn');
    const closeDrawerBtn = document.getElementById('close-drawer-btn');
    const mobileDrawer = document.getElementById('mobile-drawer');
    const drawerOverlay = document.getElementById('drawer-overlay');

    function openMobileDrawer() {
        if (mobileDrawer && drawerOverlay) {
            mobileDrawer.classList.add('open');
            drawerOverlay.classList.add('active');
        }
    }

    function closeMobileDrawer() {
        if (mobileDrawer && drawerOverlay) {
            mobileDrawer.classList.remove('open');
            drawerOverlay.classList.remove('active');
        }
    }

    if (hamburgerBtn) hamburgerBtn.addEventListener('click', openMobileDrawer);
    if (closeDrawerBtn) closeDrawerBtn.addEventListener('click', closeMobileDrawer);
    if (drawerOverlay) drawerOverlay.addEventListener('click', closeMobileDrawer);

    if (mobileDrawer) {
        mobileDrawer.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', closeMobileDrawer);
        });
    }

    // 4. Slide-Out Cart Drawer Controls & AJAX Cart API
    const cartToggleBtns = document.querySelectorAll('.js-cart-toggle');
    const cartDrawerBackdrop = document.getElementById('cart-drawer-backdrop');
    const cartDrawerPanel = document.getElementById('cart-drawer-panel');
    const cartCloseBtn = document.getElementById('cart-drawer-close');

    window.openCartDrawer = function() {
        if (cartDrawerBackdrop && cartDrawerPanel) {
            cartDrawerBackdrop.classList.add('open');
            cartDrawerPanel.classList.add('open');
            fetchShopifyCart();
        }
    };

    window.closeCartDrawer = function() {
        if (cartDrawerBackdrop && cartDrawerPanel) {
            cartDrawerBackdrop.classList.remove('open');
            cartDrawerPanel.classList.remove('open');
        }
    };

    cartToggleBtns.forEach(btn => btn.addEventListener('click', (e) => {
        e.preventDefault();
        window.openCartDrawer();
    }));

    if (cartCloseBtn) cartCloseBtn.addEventListener('click', window.closeCartDrawer);
    if (cartDrawerBackdrop) cartDrawerBackdrop.addEventListener('click', window.closeCartDrawer);

    window.getLocalCart = function() {
        try {
            return JSON.parse(localStorage.getItem('vulpera_cart')) || { items: [], item_count: 0, total_price: 0 };
        } catch(e) {
            return { items: [], item_count: 0, total_price: 0 };
        }
    };

    window.saveLocalCart = function(cart) {
        localStorage.setItem('vulpera_cart', JSON.stringify(cart));
        updateCartCount(cart.item_count);
        renderCartDrawerItems(cart);
    };

    if (isLocalPreview) {
        const originalFetch = window.fetch;
        window.fetch = function(url, options) {
            if (url === '/cart/add.js') {
                const body = JSON.parse(options.body);
                const itemToAdd = body.items[0];
                let cart = getLocalCart();
                const properties = itemToAdd.properties || {};
                const variantId = itemToAdd.id;
                
                let image = 'https://cdn.shopify.com/s/files/1/0784/1755/9776/files/ChatGPT_Image_Jul_30_2026_07_49_59_AM_1.png?v=1786601355';
                const previewImg = document.querySelector('#custom-cap-page #customizer-cap-image');
                if (previewImg) {
                    image = previewImg.src;
                }
                
                const existingIndex = cart.items.findIndex(item => {
                    return item.id === parseInt(variantId) && 
                           JSON.stringify(item.properties) === JSON.stringify(properties);
                });
                
                if (existingIndex > -1) {
                    cart.items[existingIndex].quantity += itemToAdd.quantity;
                } else {
                    cart.items.push({
                        id: parseInt(variantId),
                        product_title: 'Custom Cap',
                        variant_title: properties['_Cap Color'] || '',
                        final_line_price: 119000,
                        image: image,
                        quantity: itemToAdd.quantity,
                        properties: properties
                    });
                }
                
                let count = 0;
                let total = 0;
                cart.items.forEach(item => {
                    count += item.quantity;
                    total += item.final_line_price * item.quantity;
                });
                cart.item_count = count;
                cart.total_price = total;
                
                saveLocalCart(cart);
                return Promise.resolve(new Response(JSON.stringify(cart), {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' }
                }));
            }
            
            if (url === '/cart/change.js') {
                const body = JSON.parse(options.body);
                const line = body.line;
                const quantity = body.quantity;
                
                let cart = getLocalCart();
                if (line > 0 && line <= cart.items.length) {
                    if (quantity === 0) {
                        cart.items.splice(line - 1, 1);
                    } else {
                        cart.items[line - 1].quantity = quantity;
                    }
                    let count = 0;
                    let total = 0;
                    cart.items.forEach(item => {
                        count += item.quantity;
                        total += item.final_line_price * item.quantity;
                    });
                    cart.item_count = count;
                    cart.total_price = total;
                    saveLocalCart(cart);
                }
                return Promise.resolve(new Response(JSON.stringify(cart), {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' }
                }));
            }
            
            if (url === '/cart.js') {
                const cart = getLocalCart();
                return Promise.resolve(new Response(JSON.stringify(cart), {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' }
                }));
            }
            return originalFetch.apply(this, arguments);
        };
    }

    // Fetch dynamic Shopify cart data
    function fetchShopifyCart() {
        if (isLocalPreview) {
            const cart = getLocalCart();
            updateCartCount(cart.item_count);
            renderCartDrawerItems(cart);
            return;
        }
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                updateCartCount(cart.item_count);
                renderCartDrawerItems(cart);
            })
            .catch(err => console.log('Cart fetch notice:', err));
    }

    function updateCartCount(count) {
        document.querySelectorAll('.js-cart-count').forEach(el => {
            el.textContent = count || 0;
        });
    }

    function renderCartDrawerItems(cart) {
        const body = document.getElementById('cart-drawer-body-items');
        const totalEl = document.getElementById('cart-drawer-total-price');
        if (!body) return;

        if (!cart || cart.items.length === 0) {
            body.innerHTML = '<p style="text-align:center; color: var(--cream-muted); padding-top: 40px;">Your cart is currently empty.</p>';
            if (totalEl) totalEl.textContent = '₹0.00';
            return;
        }

        let html = '';
        cart.items.forEach((item, idx) => {
            const priceFormatted = (item.final_line_price / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
            
            // Format Properties
            let propertiesHtml = '';
            if (item.properties && Object.keys(item.properties).length > 0) {
                propertiesHtml += '<div style="margin-top:4px; font-size:0.75rem; color: var(--cream-muted); display:flex; flex-direction:column; gap:2px; margin-bottom:6px;">';
                for (const [key, value] of Object.entries(item.properties)) {
                    if (value && !key.startsWith('__')) {
                        const cleanKey = key.replace(/^_/, '');
                        propertiesHtml += `<div><span style="font-weight:600; color:var(--teal-hi);">${cleanKey}:</span> <span>${value}</span></div>`;
                    }
                }
                propertiesHtml += '</div>';
            }

            html += `
                <div style="display:flex; gap:12px; align-items:center; background: rgba(5,38,24,0.8); padding: 12px; border-radius: 12px; border: 1px solid rgba(95,176,148,0.2);">
                    <a href="${item.url || '#'}"><img src="${item.image}" alt="${item.title || item.product_title}" style="width:60px; height:60px; object-fit:cover; border-radius:8px;" /></a>
                    <div style="flex:1;">
                        <a href="${item.url || '#'}" style="text-decoration:none; color: var(--cream);"><h4 style="font-size:0.88rem; color: var(--cream); margin-bottom:4px;">${item.product_title}</h4></a>
                        <p style="font-size:0.78rem; color: var(--cream-muted);">${item.variant_title || ''}</p>
                        ${propertiesHtml}
                        <span style="font-weight:700; color: var(--orange-hi); font-size:0.85rem;">${priceFormatted} × ${item.quantity}</span>
                    </div>
                    <button onclick="changeCartItemQuantity(${idx + 1}, 0)" style="color: #ff6b6b; font-size: 1rem;"><i class="fas fa-trash"></i></button>
                </div>
            `;
        });
        body.innerHTML = html;
        if (totalEl) {
            totalEl.textContent = (cart.total_price / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
        }
    }

    window.changeCartItemQuantity = function(line, quantity) {
        if (isLocalPreview) {
            let cart = getLocalCart();
            if (line > 0 && line <= cart.items.length) {
                if (quantity === 0) {
                    cart.items.splice(line - 1, 1);
                } else {
                    cart.items[line - 1].quantity = quantity;
                }
                // Recalculate
                let count = 0;
                let total = 0;
                cart.items.forEach(item => {
                    count += item.quantity;
                    total += item.final_line_price * item.quantity;
                });
                cart.item_count = count;
                cart.total_price = total;
                saveLocalCart(cart);
            }
            return;
        }
        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: quantity })
        })
        .then(res => res.json())
        .then(cart => {
            updateCartCount(cart.item_count);
            renderCartDrawerItems(cart);
        });
    };

    // AJAX Add to Cart handler for product cards
    document.body.addEventListener('click', (e) => {
        const addBtn = e.target.closest('.js-add-to-cart');
        if (addBtn) {
            e.preventDefault();
            const variantId = addBtn.dataset.variantId;
            if (!variantId) {
                window.openCartDrawer();
                return;
            }
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
            })
            .then(res => res.json())
            .then(() => {
                window.openCartDrawer();
            })
            .catch(err => console.error('Add to cart failed:', err));
        }
    });

    // 5. Instagram Slider Control
    const track = document.getElementById('insta-track');
    let currentSlide = 0;
    const maxSlides = 2;

    window.scrollInsta = function(direction) {
        if (!track) return;
        currentSlide += direction;
        if (currentSlide < 0) currentSlide = 0;
        if (currentSlide > maxSlides) currentSlide = maxSlides;
        const shiftPercentage = currentSlide * 25;
        track.style.transform = `translateX(-${shiftPercentage}%)`;
    };

    // 5.b. Category Slider Control (with auto loop)
    const categoryTrack = document.getElementById('category-track');
    let categorySlide = 0;
    let categoryAutoPlayInterval;

    window.scrollCategories = function(direction) {
        if (!categoryTrack) return;
        const cards = categoryTrack.getElementsByClassName('category-card');
        if (!cards.length) return;
        
        const cardWidth = cards[0].offsetWidth + 20; // card width + gap
        const visibleCards = Math.round(categoryTrack.offsetWidth / cardWidth) || 1;
        const maxSlides = Math.max(0, cards.length - visibleCards);
        
        categorySlide += direction;
        if (categorySlide < 0) categorySlide = maxSlides;
        if (categorySlide > maxSlides) categorySlide = 0;
        
        categoryTrack.style.transform = `translateX(-${categorySlide * cardWidth}px)`;
    };

    function startCategoryAutoPlay() {
        categoryAutoPlayInterval = setInterval(() => {
            scrollCategories(1);
        }, 4000);
    }

    if (categoryTrack) {
        startCategoryAutoPlay();
        categoryTrack.addEventListener('mouseenter', () => clearInterval(categoryAutoPlayInterval));
        categoryTrack.addEventListener('mouseleave', () => startCategoryAutoPlay());
    }

    // 6. Search Overlay Drawer Control
    const searchModalOverlay = document.getElementById('search-modal-overlay');
    const searchModalClose = document.getElementById('search-modal-close');
    const searchModalInput = document.getElementById('search-modal-input');

    window.toggleSearch = function() {
        if (searchModalOverlay) {
            const isOpen = searchModalOverlay.classList.contains('open');
            if (isOpen) {
                searchModalOverlay.classList.remove('open');
            } else {
                searchModalOverlay.classList.add('open');
                if (searchModalInput) {
                    setTimeout(() => searchModalInput.focus(), 150);
                }
            }
        }
    };

    if (searchModalClose) {
        searchModalClose.addEventListener('click', () => {
            if (searchModalOverlay) searchModalOverlay.classList.remove('open');
        });
    }

    if (searchModalOverlay) {
        searchModalOverlay.addEventListener('click', (e) => {
            if (e.target === searchModalOverlay) {
                searchModalOverlay.classList.remove('open');
            }
        });
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && searchModalOverlay && searchModalOverlay.classList.contains('open')) {
            searchModalOverlay.classList.remove('open');
        }
    });

    // 7. Scroll reveal animations
    const sections = document.querySelectorAll('section');
    if ('IntersectionObserver' in window) {
        const sectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }
            });
        }, { threshold: 0.08 });

        sections.forEach(sec => {
            sec.style.opacity = '0';
            sec.style.transform = 'translateY(30px)';
            sec.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
            sectionObserver.observe(sec);
        });
    }

    // 8. Client-Side Wishlist System
    function getWishlist() {
        try {
            return JSON.parse(localStorage.getItem('vulpera_wishlist')) || [];
        } catch(e) {
            return [];
        }
    }

    window.toggleWishlist = function(handle) {
        let wishlist = getWishlist();
        const index = wishlist.indexOf(handle);
        if (index > -1) {
            wishlist.splice(index, 1);
        } else {
            wishlist.push(handle);
        }
        localStorage.setItem('vulpera_wishlist', JSON.stringify(wishlist));
        updateWishlistState();
        
        // If we are on the wishlist page, refresh it
        if (document.getElementById('wishlist-grid-container')) {
            window.renderWishlistPage();
        }
    };

    function updateWishlistState() {
        const wishlist = getWishlist();
        
        // Header badge counter update
        const headerWishlistBadge = document.querySelector('.icon-btn[href="/pages/wishlist"]');
        if (headerWishlistBadge) {
            if (wishlist.length > 0) {
                headerWishlistBadge.style.color = 'var(--orange-hi)';
                let countBadge = headerWishlistBadge.querySelector('.wishlist-count-badge');
                if (!countBadge) {
                    countBadge = document.createElement('span');
                    countBadge.className = 'wishlist-count-badge';
                    countBadge.style.cssText = 'background:var(--orange-hi); color:#000; font-size:0.65rem; font-weight:800; border-radius:50%; width:16px; height:16px; display:inline-flex; align-items:center; justify-content:center; position:absolute; top:-4px; right:-4px;';
                    headerWishlistBadge.style.position = 'relative';
                    headerWishlistBadge.appendChild(countBadge);
                }
                countBadge.textContent = wishlist.length;
            } else {
                headerWishlistBadge.style.color = '';
                const countBadge = headerWishlistBadge.querySelector('.wishlist-count-badge');
                if (countBadge) countBadge.remove();
            }
        }

        // Card button heart active styling updates
        document.querySelectorAll('.js-wishlist-toggle').forEach(btn => {
            const handle = btn.dataset.productHandle;
            const icon = btn.querySelector('i');
            const textSpan = btn.querySelector('.wishlist-btn-text');
            
            if (wishlist.includes(handle)) {
                if (icon) {
                    icon.className = 'fas fa-heart';
                    icon.style.color = '#ff4d4d';
                }
                if (textSpan) {
                    textSpan.textContent = 'Remove from Wishlist';
                }
                btn.classList.add('in-wishlist');
            } else {
                if (icon) {
                    icon.className = 'far fa-heart';
                    icon.style.color = '';
                }
                if (textSpan) {
                    textSpan.textContent = 'Add to Wishlist';
                }
                btn.classList.remove('in-wishlist');
            }
        });
    }

    // Bind Wishlist toggle buttons click event
    document.body.addEventListener('click', (e) => {
        const toggleBtn = e.target.closest('.js-wishlist-toggle');
        if (toggleBtn) {
            e.preventDefault();
            e.stopPropagation();
            const handle = toggleBtn.dataset.productHandle;
            if (handle) {
                window.toggleWishlist(handle);
            }
        }
    });

    // 9. Local SPA Router for Wishlist Page (Local Preview Only)
    
    function showWishlistSPA() {
        const mainContent = document.getElementById('MainContent');
        if (!mainContent) return;

        // Hide main landing content
        mainContent.style.display = 'none';

        // Check if wishlist page already exists, otherwise create it
        let wishlistPage = document.getElementById('wishlist-page');
        if (!wishlistPage) {
            wishlistPage = document.createElement('div');
            wishlistPage.id = 'wishlist-page';
            wishlistPage.className = 'wishlist-page-container';
            wishlistPage.innerHTML = `
                <div class="container">
                    <div class="wishlist-header-block">
                        <div class="wishlist-breadcrumb">
                            <a href="/" class="js-wishlist-breadcrumb-home">Homepage</a> &gt; <span>Wishlist</span>
                        </div>
                        <h1>My Wishlist</h1>
                    </div>
                    <div class="wishlist-grid" id="wishlist-grid-container">
                        <div class="wishlist-loading-indicator" id="wishlist-loader">
                            <i class="fas fa-circle-notch fa-spin" style="margin-right: 8px; color: var(--orange-hi);"></i> Loading wishlist items...
                        </div>
                    </div>
                </div>
            `;
            // Insert wishlist page before the footer
            const footer = document.getElementById('footer');
            if (footer) {
                footer.parentNode.insertBefore(wishlistPage, footer);
            } else {
                document.body.appendChild(wishlistPage);
            }

            // Bind click to the wishlist homepage breadcrumb link
            wishlistPage.querySelector('.js-wishlist-breadcrumb-home').addEventListener('click', (e) => {
                e.preventDefault();
                hideWishlistSPA();
            });
        } else {
            wishlistPage.style.display = 'block';
        }

        // Render products
        window.renderWishlistPage();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        
        // Update URL hash for simple back button / navigation state representation
        window.location.hash = 'wishlist';
        document.title = "My Wishlist – Vulpera.com";
    }

    function hideWishlistSPA() {
        const mainContent = document.getElementById('MainContent');
        const wishlistPage = document.getElementById('wishlist-page');
        if (mainContent) mainContent.style.display = 'block';
        if (wishlistPage) wishlistPage.style.display = 'none';
        
        window.location.hash = '';
        document.title = "Vulpera.com – Official Licensed Collection & Custom Caps";
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // Dynamic Wishlist Renderer (similar to Shopify liquid section script but handles local fallback files)
    window.renderWishlistPage = function() {
        const grid = document.getElementById('wishlist-grid-container');
        if (!grid) return;

        let wishlist = [];
        try {
            wishlist = JSON.parse(localStorage.getItem('vulpera_wishlist')) || [];
        } catch(e) {
            wishlist = [];
        }

        if (wishlist.length === 0) {
            grid.innerHTML = `
                <div style="text-align: center; padding-block: 60px; background: rgba(5, 38, 24, 0.7); border: 1px solid rgba(95, 176, 148, 0.25); border-radius: 16px; box-shadow: var(--shadow-card); grid-column: 1 / -1; width: 100%; display:flex; flex-direction:column; align-items:center;">
                    <i class="far fa-heart" style="font-size: 3.5rem; color: var(--teal-hi); opacity: 0.4; margin-bottom: 20px;"></i>
                    <h3 style="font-size: 1.3rem; margin-bottom: 12px; text-transform: uppercase;">Your Wishlist is empty</h3>
                    <p style="color: var(--cream-muted); margin-bottom: 24px; font-size:0.9rem;">Keep track of caps you love by clicking the heart icons.</p>
                    <a href="#listing" class="btn-orange js-wishlist-browse" style="display: inline-flex; text-decoration: none; padding: 12px 24px;">Browse Products</a>
                </div>
            `;
            const browseBtn = grid.querySelector('.js-wishlist-browse');
            if (browseBtn) {
                browseBtn.addEventListener('click', (e) => {
                    hideWishlistSPA();
                });
            }
            return;
        }

        grid.innerHTML = `
            <div class="wishlist-loading-indicator" id="wishlist-loader">
                <i class="fas fa-circle-notch fa-spin" style="margin-right: 8px; color: var(--orange-hi);"></i> Loading wishlist items...
            </div>
        `;

        // Local Preview mockup items library mapping handle -> details
        const mockProductsData = {
            'demo-product-quote-cap': { title: 'QUOTE CAP', price: '₹1,399.00', image: 'images/prod_1.jpg' },
            'demo-product-garfield-orange-cap': { title: 'GARFIELD ORANGE CAP', price: '₹1,399.00', image: 'images/prod_2.jpg' },
            'demo-product-adventure-cap': { title: 'ADVENTURE CAP', price: '₹1,399.00', image: 'images/prod_3.jpg' },
            'demo-product-pattern-cap': { title: 'PATTERN CAP', price: '₹1,399.00', image: 'images/prod_4.jpg' },
            'demo-product-hulk-cap': { title: 'HULK CAP', price: '₹1,399.00', image: 'images/new_1.jpg' },
            'demo-product-green-round-cap': { title: 'GREEN ROUND CAP', price: '₹1,399.00', image: 'images/new_2.jpg' },
            'demo-product-garfield-brown-cap': { title: 'GARFIELD BROWN CAP', price: '₹1,399.00', image: 'images/new_3.jpg' },
            'demo-product-green-camo-cap': { title: 'GREEN CAMO CAP', price: '₹1,399.00', image: 'images/new_4.jpg' }
        };

        // Fetch products or use local mockups
        let html = '';
        let validItemsCount = 0;
        wishlist.forEach(handle => {
            const prod = mockProductsData[handle] || { title: handle.replace(/-/g, ' ').toUpperCase(), price: '₹1,399.00', image: 'https://cdn.shopify.com/s/files/1/0784/1755/9776/files/ChatGPT_Image_Jul_30_2026_07_49_59_AM_1.png?v=1786601355' };
            validItemsCount++;
            html += `
                <div class="product-card">
                    <div class="product-img-wrap" style="position: relative;">
                        <a href="#"><img src="${prod.image}" alt="${prod.title}" style="width:100%; height:100%; object-fit:cover;" /></a>
                        <button type="button" class="wishlist-toggle-btn js-wishlist-toggle" data-product-handle="${handle}" aria-label="Remove from Wishlist" style="position: absolute; top: 12px; right: 12px; border: none; background: rgba(5, 38, 24, 0.85); width: 34px; height: 34px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: var(--cream); cursor: pointer; border: 1px solid rgba(255,255,255,0.15); z-index: 10; transition: all 0.2s;">
                            <i class="fas fa-heart" style="color: #ff4d4d;"></i>
                        </button>
                    </div>
                    <div class="product-info">
                        <div class="product-stars">
                            <i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>
                        </div>
                        <div class="product-title">${prod.title}</div>
                        <div class="product-price">${prod.price}</div>
                        <button type="button" class="product-add-btn js-cart-toggle">
                            <i class="fas fa-shopping-bag" style="margin-right: 4px;"></i> Add to Bag
                        </button>
                    </div>
                </div>
            `;
        });

        if (validItemsCount === 0) {
            grid.innerHTML = `
                <div style="text-align: center; padding-block: 60px; background: rgba(5, 38, 24, 0.7); border: 1px solid rgba(95, 176, 148, 0.25); border-radius: 16px; box-shadow: var(--shadow-card); grid-column: 1 / -1; width: 100%; display:flex; flex-direction:column; align-items:center;">
                    <i class="far fa-heart" style="font-size: 3.5rem; color: var(--teal-hi); opacity: 0.4; margin-bottom: 20px;"></i>
                    <h3 style="font-size: 1.3rem; margin-bottom: 12px; text-transform: uppercase;">Your Wishlist is empty</h3>
                    <p style="color: var(--cream-muted); margin-bottom: 24px; font-size:0.9rem;">Keep track of caps you love by clicking the heart icons.</p>
                    <a href="#listing" class="btn-orange js-wishlist-browse" style="display: inline-flex; text-decoration: none; padding: 12px 24px;">Browse Products</a>
                </div>
            `;
        } else {
            grid.innerHTML = html;
        }
    };

    // 9.b Local SPA Router for Custom Cap Customizer Page (Local Preview Only)
    window.showCustomCapSPA = function() {
        const mainContent = document.getElementById('MainContent');
        const wishlistPage = document.getElementById('wishlist-page');
        if (!mainContent) return;

        // Hide landing content & wishlist
        mainContent.style.display = 'none';
        if (wishlistPage) wishlistPage.style.display = 'none';

        // Check if custom cap page already exists, otherwise create it
        let customCapPage = document.getElementById('custom-cap-page');
        if (!customCapPage) {
            customCapPage = document.createElement('div');
            customCapPage.id = 'custom-cap-page';
            customCapPage.className = 'custom-cap-page-container';
            
            // Create mockup content of customizer page matching our liquid file
            customCapPage.innerHTML = `
                <div class="vulpera-custom-cap-section">
                  
                  <!-- ── Hero Banner Section ── -->
                  <div class="custom-cap-hero">
                    <div class="container" style="width: 100%;">
                      <div class="breadcrumb-nav" style="color: var(--cream-muted); padding-bottom: 10px;">
                        <a href="/" class="js-custom-cap-breadcrumb-home" style="color: var(--teal-pale);">Home</a> &gt; <span>Custom caps</span>
                      </div>
                      
                      <div class="custom-cap-hero-content">
                        <h1 class="custom-cap-hero-title">Design Your Custom Cap</h1>
                        <h2 class="custom-cap-hero-subheading">Personalize Your Vulpera Cap</h2>
                        <p class="custom-cap-hero-desc">
                          Create a cap that's uniquely yours. Add your name, initials, team identity, or custom text using our premium embroidery options. Choose from curated fonts, colors, and styles while enjoying Vulpera's signature quality and craftsmanship.
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- ── Customizer Workspace ── -->
                  <div class="container" style="padding-top: 50px;">
                    <div class="vulpera-customizer-grid">
                      
                      <!-- Left: Preview Column -->
                      <div class="vulpera-preview-column">
                        <div class="vulpera-preview-box-wrapper">
                          <div class="vulpera-preview-badge">
                            <span class="pulse-dot"></span> Live Preview
                          </div>
                          <div class="vulpera-cap-preview-container" id="cap-preview-container">
                            <img id="customizer-cap-image" src="https://cdn.shopify.com/s/files/1/0784/1755/9776/files/Untitled_design_3.png?v=1786541075" alt="Cap Live Preview" />
                            <div id="customizer-text-overlay" class="customizer-text-overlay"></div>
                          </div>
                        </div>
                      </div>

                      <!-- Right: Controls Column -->
                      <div class="vulpera-controls-column">
                        <div class="vulpera-controls-card">

                          <form id="vulpera-custom-cap-form">
                            <input type="hidden" name="id" id="customizer-variant-id" value="44123456">
                            <input type="hidden" name="properties[_Custom Text]" id="prop-custom-text" value="">
                            <input type="hidden" name="properties[_Cap Color]" id="prop-cap-color" value="Beige">
                            <input type="hidden" name="properties[_Font Color]" id="prop-font-color" value="White">
                            <input type="hidden" name="properties[_Font Style]" id="prop-font-style" value="Classic">
                            <input type="hidden" name="properties[_Text Position]" id="prop-text-position" value="Center">

                            <!-- 1. Text input -->
                            <div class="control-group">
                              <div class="control-label-row">
                                <label for="customizer-text" class="control-label">Type Custom Text</label>
                                <span class="char-counter" id="customizer-char-counter">0 / 10</span>
                              </div>
                              <input type="text" id="customizer-text" maxlength="10" placeholder="Type up to 10 characters..." class="vulpera-input" autocomplete="off" />
                            </div>

                            <!-- 2. Font Style buttons -->
                            <div class="control-group">
                              <span class="control-label">Choose Font Style</span>
                              <div class="font-style-grid">
                                <button type="button" class="style-select-btn active" data-style="Modern" style="font-family: 'Montserrat', sans-serif; font-weight: 800;">Modern</button>
                                <button type="button" class="style-select-btn" data-style="Athletic" style="font-family: 'Anton', sans-serif; text-transform: uppercase;">Athletic</button>
                                <button type="button" class="style-select-btn" data-style="Heritage" style="font-family: 'Roboto Slab', serif; font-weight: 700;">Heritage</button>
                                <button type="button" class="style-select-btn" data-style="Signature" style="font-family: 'Lobster', cursive;">Signature</button>
                              </div>
                            </div>

                            <!-- 3. Font Color Swatches -->
                            <div class="control-group">
                              <span class="control-label">Select Font Color</span>
                              <div class="font-color-swatches">
                                <button type="button" class="color-swatch-btn active" data-color="White" style="background-color: #ffffff;" aria-label="White color select"></button>
                                <button type="button" class="color-swatch-btn" data-color="Black" style="background-color: #000000;" aria-label="Black color select"></button>
                                <button type="button" class="color-swatch-btn" data-color="Red" style="background-color: #e60023;" aria-label="Red color select"></button>
                                <button type="button" class="color-swatch-btn" data-color="Blue" style="background-color: #0000ff;" aria-label="Blue color select"></button>
                              </div>
                            </div>

                            <!-- 4. Cap Base color -->
                            <div class="control-group">
                              <span class="control-label">Choose Cap Base</span>
                              <div class="cap-base-grid" id="cap-base-grid">
                                <div class="cap-base-item active" data-variant-id="44123456" data-color-name="Beige" data-image-url="https://cdn.shopify.com/s/files/1/0784/1755/9776/files/Untitled_design_3.png?v=1786541075" data-price="₹1,190.00" title="Beige">
                                  <img src="https://cdn.shopify.com/s/files/1/0784/1755/9776/files/Untitled_design_3.png?v=1786541075" alt="Beige Cap" />
                                </div>
                                <div class="cap-base-item" data-variant-id="44123457" data-color-name="Black" data-image-url="https://cdn.shopify.com/s/files/1/0784/1755/9776/files/ChatGPT_Image_Jul_30_2026_07_49_59_AM_1.png?v=1786601355" data-price="₹1,190.00" title="Black">
                                  <img src="https://cdn.shopify.com/s/files/1/0784/1755/9776/files/ChatGPT_Image_Jul_30_2026_07_49_59_AM_1.png?v=1786601355" alt="Black Cap" />
                                </div>
                                <div class="cap-base-item" data-variant-id="44123458" data-color-name="Green" data-image-url="https://cdn.shopify.com/s/files/1/0784/1755/9776/files/Vulp-Grn-Velv-web-Front_Box_1.png?v=1786600834" data-price="₹1,190.00" title="Green">
                                  <img src="https://cdn.shopify.com/s/files/1/0784/1755/9776/files/Vulp-Grn-Velv-web-Front_Box_1.png?v=1786600834" alt="Green Cap" />
                                </div>
                                <div class="cap-base-item" data-variant-id="44123459" data-color-name="Navy" data-image-url="https://cdn.shopify.com/s/files/1/0784/1755/9776/files/magnific_ultradetailed-prompt-a-hy_Syw3cX5Ub8_1_2.png?v=1786971501" data-price="₹1,190.00" title="Navy">
                                  <img src="https://cdn.shopify.com/s/files/1/0784/1755/9776/files/magnific_ultradetailed-prompt-a-hy_Syw3cX5Ub8_1_2.png?v=1786971501" alt="Navy Cap" />
                                </div>
                              </div>
                            </div>

                            <div class="section-divider" style="margin-block: 25px 20px;"></div>

                            <!-- Price & Add-To-Cart -->
                            <div class="vulpera-customizer-price-row">
                              <span class="price-label">Price:</span>
                              <span class="price-amount" id="customizer-price-display">₹1,190.00</span>
                            </div>

                            <div class="vulpera-customizer-atc-actions">
                              <button type="submit" id="customizer-add-to-cart" class="btn-orange" style="width: 100%; border: none; padding-block: 18px; font-size: 1.1rem; justify-content: center; display: inline-flex; align-items: center; gap: 8px;">
                                <i class="fas fa-shopping-bag"></i> Add to Cart
                              </button>
                            </div>

                          </form>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
            `;

            // Insert customizer page before the footer
            const footer = document.getElementById('footer');
            if (footer) {
                footer.parentNode.insertBefore(customCapPage, footer);
            } else {
                document.body.appendChild(customCapPage);
            }

            // Bind click to breadcrumb link to go back home
            customCapPage.querySelectorAll('.js-custom-cap-breadcrumb-home').forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    hideCustomCapSPA();
                });
            });

            // Initialize customizer script for local SPA
            initializeLocalCustomizer();
        } else {
            customCapPage.style.display = 'block';
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
        window.location.hash = 'custom-cap';
        document.title = "Design Your Custom Cap – Vulpera.com";
    };

    window.hideCustomCapSPA = function() {
        const mainContent = document.getElementById('MainContent');
        const customCapPage = document.getElementById('custom-cap-page');
        if (mainContent) mainContent.style.display = 'block';
        if (customCapPage) customCapPage.style.display = 'none';

        window.location.hash = '';
        document.title = "Vulpera.com – Official Licensed Collection & Custom Caps";
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    function initializeLocalCustomizer() {
        const form = document.querySelector('#custom-cap-page #vulpera-custom-cap-form');
        if (!form) return;

        const textInput = form.querySelector('#customizer-text');
        const charCounter = form.querySelector('#customizer-char-counter');
        const textOverlay = document.querySelector('#custom-cap-page #customizer-text-overlay');
        const capImg = document.querySelector('#custom-cap-page #customizer-cap-image');
        const priceDisplay = form.querySelector('#customizer-price-display');

        const propCustomText = form.querySelector('#prop-custom-text');
        const propCapColor = form.querySelector('#prop-cap-color');
        const propFontColor = form.querySelector('#prop-font-color');
        const propFontStyle = form.querySelector('#prop-font-style');
        const variantIdInput = form.querySelector('#customizer-variant-id');

        let activeCapColor = 'Beige';
        let activeStyle = 'Modern';
        let activeColor = 'White';

        const fontStyles = {
          Modern: { fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase', letterSpacing: '0.04em' },
          Athletic: { fontFamily: "'Anton', sans-serif", textTransform: 'uppercase', letterSpacing: '0.06em' },
          Heritage: { fontFamily: "'Roboto Slab', serif", textTransform: 'none', letterSpacing: 'normal' },
          Signature: { fontFamily: "'Lobster', cursive", textTransform: 'none', letterSpacing: 'normal' }
        };

        const fontColors = {
          White: '#ffffff',
          Black: '#000000',
          Red: '#e60023',
          Blue: '#0000ff'
        };

        const capBaseItems = form.querySelectorAll('.cap-base-item');
        capBaseItems.forEach(item => {
          item.addEventListener('click', () => {
            capBaseItems.forEach(i => i.classList.remove('active'));
            item.classList.add('active');

            const colorName = item.dataset.colorName;
            const imageUrl = item.dataset.imageUrl;
            const priceStr = item.dataset.price;
            const varId = item.dataset.variantId;

            activeCapColor = colorName;
            capImg.src = imageUrl;
            variantIdInput.value = varId;
            propCapColor.value = colorName;
            if (priceDisplay) priceDisplay.textContent = priceStr;
          });
        });

        const styleButtons = form.querySelectorAll('.style-select-btn');
        styleButtons.forEach(btn => {
          btn.addEventListener('click', () => {
            styleButtons.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            activeStyle = btn.dataset.style;
            propFontStyle.value = activeStyle;
            updateLocalTextPreview();
          });
        });

        const colorSwatches = form.querySelectorAll('.color-swatch-btn');
        colorSwatches.forEach(swatch => {
          swatch.addEventListener('click', () => {
            colorSwatches.forEach(s => s.classList.remove('active'));
            swatch.classList.add('active');
            activeColor = swatch.dataset.color;
            propFontColor.value = activeColor;
            updateLocalTextPreview();
          });
        });

        textInput.addEventListener('input', () => {
          let text = textInput.value;
          if (text.length > 10) {
            text = text.substring(0, 10);
            textInput.value = text;
          }
          charCounter.textContent = `${text.length} / 10`;
          propCustomText.value = text || '(Plain Cap)';
          updateLocalTextPreview();
        });

        function updateLocalTextPreview() {
          const textVal = textInput.value;
          textOverlay.textContent = textVal;

          const styling = fontStyles[activeStyle];
          textOverlay.style.fontFamily = styling.fontFamily;
          textOverlay.style.textTransform = styling.textTransform;
          textOverlay.style.letterSpacing = styling.letterSpacing;
          textOverlay.style.color = fontColors[activeColor];

          let baseSize = 25;
          if (window.innerWidth < 768) {
            baseSize = 18;
          } else if (window.innerWidth < 1024) {
            baseSize = 21;
          }

          let length = textVal.length;
          let finalSize = baseSize;
          if (length > 6) {
            finalSize = baseSize - (length - 6) * 1.5;
          }
          textOverlay.style.fontSize = `${finalSize}px`;
        }

        window.addEventListener('resize', updateLocalTextPreview);

        form.addEventListener('submit', (e) => {
          e.preventDefault();
          const textValue = textInput.value.trim();
          const variantId = variantIdInput.value;
          const atcButton = form.querySelector('#customizer-add-to-cart');
          const originalHtml = atcButton.innerHTML;

          if (textValue.length > 10) {
            alert('Customization text cannot exceed 10 characters.');
            return;
          }

          const properties = {
            '_Custom Text': textValue || '(Plain Cap)',
            '_Cap Color': activeCapColor,
            '_Font Color': activeColor,
            '_Font Style': activeStyle,
            '_Text Position': 'Center'
          };

          atcButton.disabled = true;
          atcButton.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i> Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: parseInt(variantId),
                quantity: 1,
                properties: properties
              }]
            })
          })
          .then(res => res.json())
          .then(() => {
            atcButton.disabled = false;
            atcButton.innerHTML = originalHtml;
            if (window.openCartDrawer) {
              window.openCartDrawer();
            }
          })
          .catch(err => {
            console.error(err);
            atcButton.disabled = false;
            atcButton.innerHTML = originalHtml;
          });
        });
    }

    if (isLocalPreview) {
        // Intercept clicks on links pointing to /pages/wishlist
        document.body.addEventListener('click', (e) => {
            const wishlistLink = e.target.closest('a[href="/pages/wishlist"], .js-wishlist-header-link');
            if (wishlistLink) {
                e.preventDefault();
                showWishlistSPA();
            }

            // Intercept Custom Cap Links
            const customCapLink = e.target.closest('a[href*="/products/custom-cap"], a[href*="/products/custom-caps"], .js-custom-cap-link');
            if (customCapLink) {
                e.preventDefault();
                showCustomCapSPA();
            }

            // Brand logo home clicks
            const homeLink = e.target.closest('.js-home-logo-link, a[href="/"], a[href="#"]');
            if (homeLink) {
                const wishlistOpen = document.getElementById('wishlist-page') && document.getElementById('wishlist-page').style.display === 'block';
                const customCapOpen = document.getElementById('custom-cap-page') && document.getElementById('custom-cap-page').style.display === 'block';
                if (wishlistOpen || customCapOpen) {
                    e.preventDefault();
                    hideWishlistSPA();
                    hideCustomCapSPA();
                }
            }
        });

        // Hash change navigation support
        window.addEventListener('hashchange', () => {
            if (window.location.hash === '#wishlist') {
                showWishlistSPA();
            } else if (window.location.hash === '#custom-cap') {
                showCustomCapSPA();
            } else if (!window.location.hash) {
                hideWishlistSPA();
                hideCustomCapSPA();
            }
        });

        // Check if hash matches on initial load
        if (window.location.hash === '#wishlist') {
            showWishlistSPA();
        } else if (window.location.hash === '#custom-cap') {
            showCustomCapSPA();
        }
    }

    // 8. Gifting Option Flow
    const drawerIsGift = document.getElementById('cart-drawer-is-gift');
    const drawerMsgWrap = document.getElementById('cart-drawer-gift-message-wrap');
    const drawerMsgInput = document.getElementById('cart-drawer-gift-message');

    const mainIsGift = document.getElementById('cart-main-is-gift');
    const mainMsgWrap = document.getElementById('cart-main-gift-message-wrap');
    const mainMsgInput = document.getElementById('cart-main-gift-message');

    let giftUpdateTimeout;
    function saveGiftAttributesAJAX(isGift, message) {
        clearTimeout(giftUpdateTimeout);
        giftUpdateTimeout = setTimeout(() => {
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    attributes: {
                        is_gift: isGift ? 'yes' : 'no',
                        gift_message: isGift ? message : ''
                    }
                })
            })
            .then(res => res.json())
            .then(cart => {
                console.log('AJAX: Gift attributes saved:', cart.attributes);
            })
            .catch(err => {
                console.error('AJAX Error saving gift attributes:', err);
            });
        }, 600);
    }

    function syncGiftState(isGift, message) {
        // Sync drawer elements
        if (drawerIsGift) drawerIsGift.checked = isGift;
        if (drawerMsgWrap) drawerMsgWrap.style.display = isGift ? 'block' : 'none';
        if (drawerMsgInput) drawerMsgInput.value = message;

        // Sync main page elements
        if (mainIsGift) mainIsGift.checked = isGift;
        if (mainMsgWrap) mainMsgWrap.style.display = isGift ? 'block' : 'none';
        if (mainMsgInput) mainMsgInput.value = message;

        // Save state
        if (isLocalPreview) {
            localStorage.setItem('cart_is_gift', isGift ? 'yes' : 'no');
            localStorage.setItem('cart_gift_message', message);
        } else {
            saveGiftAttributesAJAX(isGift, message);
        }
    }

    // Bind events
    if (drawerIsGift) {
        drawerIsGift.addEventListener('change', (e) => {
            const isChecked = e.target.checked;
            const msg = drawerMsgInput ? drawerMsgInput.value : '';
            syncGiftState(isChecked, msg);
        });
    }
    if (drawerMsgInput) {
        drawerMsgInput.addEventListener('input', (e) => {
            const isChecked = drawerIsGift ? drawerIsGift.checked : false;
            syncGiftState(isChecked, e.target.value);
        });
    }
    if (mainIsGift) {
        mainIsGift.addEventListener('change', (e) => {
            const isChecked = e.target.checked;
            const msg = mainMsgInput ? mainMsgInput.value : '';
            syncGiftState(isChecked, msg);
        });
    }
    if (mainMsgInput) {
        mainMsgInput.addEventListener('input', (e) => {
            const isChecked = mainIsGift ? mainIsGift.checked : false;
            syncGiftState(isChecked, e.target.value);
        });
    }

    // Load initial preview state from localStorage if local preview
    if (isLocalPreview) {
        const storedIsGift = localStorage.getItem('cart_is_gift') === 'yes';
        const storedMsg = localStorage.getItem('cart_gift_message') || '';
        syncGiftState(storedIsGift, storedMsg);
    }

    // Initialize state on load
    updateWishlistState();
});
